import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomTooltip from "./CustomTooltip";


const TooltipLabel = ({ label, tooltip }) => {
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Typography fontSize={14}>
        {label}
      </Typography>

      <CustomTooltip title={tooltip}>
        <InfoOutlinedIcon
          fontSize="small"
          sx={{ cursor: "pointer", fontSize: "16px", color: "#3ba3dbff" }}
        />
      </CustomTooltip>
    </Box>
  );
};

export default TooltipLabel;
